import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ScreenLoader: React.FC = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    return (
        <div className="fixed inset-0 z-[10000] min-h-[100dvh] bg-[#050505] flex flex-col items-center justify-center overflow-hidden animate-in fade-in duration-700">
            
            {/* Cinematic Spatial Glow */}
            <motion.div 
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] max-w-[400px] aspect-square rounded-full blur-[100px] pointer-events-none"
                style={{
                    background: 'radial-gradient(circle, rgba(242,127,13,0.15) 0%, rgba(242,127,13,0) 70%)'
                }}
                animate={{
                    scale: [1, 1.15, 1],
                    opacity: [0.5, 0.8, 0.5],
                }}
                transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
            />
 
            {/* Breathing Premium Logo */}
            <motion.div 
                className="relative z-10"
                animate={{
                    scale: [0.97, 1.03, 0.97],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
            >
                <div className="size-24 md:size-28 rounded-full overflow-hidden shadow-[0_0_40px_rgba(242,127,13,0.25)] relative group" style={{ border: '0', outline: 'none', clipPath: 'circle(50%)', WebkitClipPath: 'circle(50%)' }}>
                    <div 
                        className="w-full h-full transition-opacity duration-200" 
                        style={{ 
                            backgroundImage: "url('/icon-192x192.png')",
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            opacity: isLoaded ? 1 : 0,
                            borderRadius: '50%'
                        }}
                    />
                    <img 
                        src="/icon-192x192.png" 
                        alt="" 
                        style={{ position: 'absolute', width: 0, height: 0, opacity: 0, pointerEvents: 'none', border: 0, outline: 'none' }} 
                        onLoad={() => setIsLoaded(true)}
                    />
                    
                    {/* Internal Shimmer */}
                    <div className="absolute inset-0 z-20 pointer-events-none bg-gradient-to-tr from-transparent via-white/5 to-transparent blur-[2px]"></div>
                </div>
            </motion.div>
            
            {/* Elegant Branding Text below */}
            <motion.div 
                className="absolute bottom-16 left-1/2 text-center whitespace-nowrap"
                initial={{ opacity: 0, y: 10, x: "-50%" }}
                animate={{ opacity: 1, y: 0, x: "-50%" }}
                transition={{ delay: 0.5, duration: 1 }}
            >
                <span className="text-[10px] font-black uppercase tracking-[0.3em] text-white/30">
                    Aura Method
                </span>
            </motion.div>
        </div>
    );
};

export default ScreenLoader;
